module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newprovider":"New report provider"},"fr":{"newprovider":"Nouveau report provider"}}')
  delete Component.options._Ctor
}
